var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.518 1.296a.63.63 0 0 1 .63-.63 6.303 6.303 0 0 1 6.296 6.297.63.63 0 1 1-1.26 0 5.043 5.043 0 0 0-5.036-5.037.63.63 0 0 1-.63-.63m.63 3.149a2.52 2.52 0 0 1 2.518 2.518.63.63 0 0 0 1.26 0 3.78 3.78 0 0 0-3.778-3.778.63.63 0 1 0 0 1.26m5.725 6.761a1.95 1.95 0 0 1 0 2.757l-.573.66C9.143 19.56-3.405 7.015 1.455 1.842l.725-.63a1.94 1.94 0 0 1 2.724.025c.02.02 1.186 1.535 1.186 1.535a1.95 1.95 0 0 1-.004 2.696l-.73.917a8.05 8.05 0 0 0 4.365 4.373l.922-.734a1.95 1.95 0 0 1 2.695-.003s1.515 1.166 1.535 1.185m-.866.916s-1.507-1.16-1.527-1.18a.69.69 0 0 0-.975 0c-.017.019-1.287 1.03-1.287 1.03a.63.63 0 0 1-.616.096 9.45 9.45 0 0 1-5.554-5.546.63.63 0 0 1 .09-.63s1.013-1.27 1.03-1.286a.693.693 0 0 0 0-.976 257 257 0 0 1-1.179-1.526.693.693 0 0 0-.95.024l-.725.63C-1.238 7.029 9.636 17.3 13.38 13.763l.574-.661a.706.706 0 0 0 .054-.98"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.333.667h15.111v15.11H.333z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call_icon.05a019954bc1898d07a09d74a9c366e8.svg";
export { ForwardRef as ReactComponent };